(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tlb-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tlb-size-guide')) {
    class TlbSizeGuide extends HTMLElement {
      static locks = 0;
      static previousOverflow = '';
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-guide-open]');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        if (!this.dialog || !this.trigger) return;
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.returnFocus = document.activeElement;
          this.dialog.showModal();
          if (TlbSizeGuide.locks++ === 0) {
            TlbSizeGuide.previousOverflow = document.documentElement.style.overflow;
            document.documentElement.style.overflow = 'hidden';
          }
          this.locked = true;
          this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.focus();
        }, options);
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.release(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index), options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.selectTab(next);
            this.tabs[next].focus();
          }, options);
        });
        this.querySelectorAll('[data-guide-brand]').forEach(button => {
          button.addEventListener('click', () => {
            const panel = button.closest('[role="tabpanel"]');
            panel.querySelectorAll('[data-guide-brand]').forEach(choice => {
              choice.setAttribute('aria-pressed', String(choice === button));
            });
            panel.querySelectorAll('[data-guide-chart]').forEach(chart => {
              chart.hidden = chart.dataset.guideChart !== button.dataset.guideBrand;
            });
          }, options);
        });
      }
      selectTab(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
      }
      release() {
        if (!this.locked) return;
        this.locked = false;
        TlbSizeGuide.locks = Math.max(0, TlbSizeGuide.locks - 1);
        if (TlbSizeGuide.locks === 0) document.documentElement.style.overflow = TlbSizeGuide.previousOverflow;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.release();
      }
    }
    customElements.define('tlb-size-guide', TlbSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
